var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-center justify-center"},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":"48","color":"primary"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }